import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
import en from '@/lang/en.json'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { en }// set locale messages
})

// inject a handler for `myOption` custom option
Vue.prototype.$i18nName = function (i18nName) {
  var name
  if (i18nName === undefined) {
    return '<>'
  }
  switch (this.$i18n.locale) {
    case 'nl':
      name = i18nName.DUT_NAAM; break
    case 'en':
      name = i18nName.ENG_NAAM; break
    case 'fr':
      name = i18nName.FRF_NAAM; break
    case 'de':
      name = i18nName.GED_NAAM; break
    case 'es':
      name = i18nName.SPE_NAAM; break
  }
  if (name !== '') {
    return name
  }
  // check fallback language
  if (i18nName.ENG_NAAM !== '') {
    return i18nName.ENG_NAAM + ' (en)'
  }
  // find first non-empty language string
  if (i18nName.DUT_NAAM !== '') {
    return i18nName.DUT_NAAM + ' (nl)'
  }
  if (i18nName.FRF_NAAM !== '') {
    return i18nName.FRF_NAAM + ' (fr)'
  }
  if (i18nName.GED_NAAM !== '') {
    return i18nName.GED_NAAM + ' (de)'
  }
  if (i18nName.SPE_NAAM !== '') {
    return i18nName.SPE_NAAM + ' (es)'
  }
  return ''
}

Vue.prototype.$i18nNameEnclosed = function (i18nName, enclosingString) {
  var name = this.$i18nName(i18nName)
  if (name.length === 0) return name
  return enclosingString[0] + name + enclosingString[1]
}

Vue.prototype.$langLabels = function () {
  var ll = Object.values(this.$store.state.languages).map(obj => obj.key).slice(0)
  var idx = ll.indexOf(this.$i18n.locale)
  ll.splice(idx, 1)
  return ll
}

Vue.prototype.$language = function () {
  return this.$i18n.locale
}

Vue.prototype.$valuesPolyfill = function (object) {
  return Object.keys(object).map(key => object[key])
}



// WEBPACK FOOTER //
// ./src/i18n/index.js